import { t, type TranslationKey } from "../i18n/t";
import type { CheckStatus } from "../api/types";

/** §B5.1/§B7.3: four values, each with its own text and tone; the dot is decoration (§3 status pill). */
export function StatusPill({ status }: { status: CheckStatus }): JSX.Element {
  return (
    <span className={`pill pill--${status}`}>
      <span className="pill__dot" aria-hidden="true" />
      {t(`check.${status}` as TranslationKey)}
    </span>
  );
}
